<template>
    <section id="congrats" class="page">
        <header class="main fixed">
            <h1><img class="button" src="img/close.svg" width="18" alt="" @click="$router.push('choice')" />Gratulacje</h1>
        </header>

        <div class="content v-center force-v-center">
            <img src="img/thumb.svg" width="58" alt="" />
            <h2>GRATULACJE!</h2>
            <div class="circle-btn">
                <router-link :to="{ name: 'choice' }">
                    <img src="img/repeat.svg" alt="" /></a>
                </router-link>
            </div>
            <p class="link"><a href="https://www.easyvoice.pl/" target="_blank">Przejdź do easyvoice.pl</a></p>
        </div>

        <footer class="main">
            <p class="partner">Partner aplikacji: <img src="img/logo_isla.png" width="100" alt="" /></p>
        </footer>
    </section>
</template>

<script>
import touch from '../mixins/touch'

export default {
    name: 'Choice',
    mixins: [touch]
}
</script>
